<template>
	<component :is="renderAs" v-bind="$attrs"> <slot /> </component>
</template>

<script>
// NOTE: these components could also be imported with `import.meta.glob('shared/components/ConsoleViewers/ArgArithmetic.vue', {eager: true})` and calling `defineComponent()` on every result element, but I found this manual import to be more explicit.
import ArgArithmetic from 'shared/components/ConsoleViewers/ArgArithmetic.vue'
import ArgArray from 'shared/components/ConsoleViewers/ArgArray.vue'
import ArgClass from 'shared/components/ConsoleViewers/ArgClass.vue'
import ArgDate from 'shared/components/ConsoleViewers/ArgDate.vue'
import ArgDefault from 'shared/components/ConsoleViewers/ArgDefault.vue'
import ArgError from 'shared/components/ConsoleViewers/ArgError.vue'
import ArgFunction from 'shared/components/ConsoleViewers/ArgFunction.vue'
import ArgHtml from 'shared/components/ConsoleViewers/ArgHtml.vue'
import ArgKeystrokes from 'shared/components/ConsoleViewers/ArgKeystrokes.vue'
import ArgMap from 'shared/components/ConsoleViewers/ArgMap.vue'
import ArgObject from 'shared/components/ConsoleViewers/ArgObject.vue'
import ArgReact from 'shared/components/ConsoleViewers/ArgReact.vue'
import ArgRef from 'shared/components/ConsoleViewers/ArgRef.vue'
import ArgRegex from 'shared/components/ConsoleViewers/ArgRegex.vue'
import ArgSerialized from 'shared/components/ConsoleViewers/ArgSerialized.vue'
import ArgSet from 'shared/components/ConsoleViewers/ArgSet.vue'
import ArgSimple from 'shared/components/ConsoleViewers/ArgSimple.vue'
import ArgString from 'shared/components/ConsoleViewers/ArgString.vue'
import ArgSymbol from 'shared/components/ConsoleViewers/ArgSymbol.vue'
import ArgTypedArray from 'shared/components/ConsoleViewers/ArgTypedArray.vue'
import ArgUndefined from 'shared/components/ConsoleViewers/ArgUndefined.vue'
import ArgValue from 'shared/components/ConsoleViewers/ArgValue.vue'
import ArgVue from 'shared/components/ConsoleViewers/ArgVue.vue'

export default {
	name: 'ConsoleEventArg',
	components: {
		ArgArithmetic,
		ArgArray,
		ArgClass,
		ArgDate,
		ArgDefault,
		ArgError,
		ArgFunction,
		ArgHtml,
		ArgKeystrokes,
		ArgMap,
		ArgObject,
		ArgReact,
		ArgRef,
		ArgRegex,
		ArgSerialized,
		ArgSet,
		ArgSimple,
		ArgString,
		ArgSymbol,
		ArgTypedArray,
		ArgUndefined,
		ArgValue,
		ArgVue,
	},
	props: {
		renderAs: String,
		// NOTE: This component can receive any of the props of any of the imported components; These props are not defined here.
	},
}
</script>
